import Input from '@amzn/awsui-components-react/polaris/input';
import SpaceBetween from '@amzn/awsui-components-react/polaris/space-between';
import React from 'react';
import styles from './InputWithIcon.module.scss';

interface InputWithIconProps {
  value: string;
  icon: JSX.Element;
  type?: any;
  onChange: (value: string) => void;
  onBlur?: () => void;
  disabled: boolean;
  direction?: 'horizontal' | 'vertical';
  'data-testid'?: string;
}

export const InputWithIcon: React.FC<InputWithIconProps> = ({
  value,
  icon,
  type,
  onChange,
  onBlur,
  disabled,
  direction,
  ...rest
}) => {
  return (
    <SpaceBetween direction={direction} size="xs">
      <Input
        className="inline numeric-input"
        data-testid={rest['data-testid'] || null}
        value={value}
        type={type}
        onChange={({ detail }) => onChange(detail.value)}
        onBlur={onBlur}
        disabled={disabled}
      />
      <div className={styles.iconContainer}>
        <div className={styles.inputIcon}>{icon}</div>
      </div>
    </SpaceBetween>
  );
};
